import React, { ChangeEvent, MutableRefObject, useEffect, useRef, useState } from 'react'
import { InputGroupPropsTypes } from '../inputComp/InputGroupType'
import { CalenderIcon, CloseIcon, DepartmentIcon, DocumentIcon, DownIcon, FormIconDataPicker, IdIcon, MobileIcon, NewWarningIcon, SearchIcon, UpIcon } from '../iconSet/IconSet'
import { SelectItemTypes } from '../../CommonTypes'
import InputGroup from '../inputComp/InputGroup'
import { AdministrativeLevel, AdministrativeLevels, EarlyWarning, EarlyWarningTypeTypes, FlatAdmin, MWAAdminData, MWADataRefType, ResponseGetActiveWarningDto, TWAdminData, TWDataRefType } from './CreateWarningTypes'
import { getAdminLevelByCode, maldivesAdministrativeLevel, maldivesSeaAdministrativeLevel, sriLankaAdministrationLevel, sriLankaSeaAdministrationLevel } from './FixedDataSet'
import { convertToOffsetDateTime, flatMap, paginationList, parseCSVManually, sideFieldCount, SubscriberDataType, validateCSVFormat } from './CommonMethods'
import useInputValidate from '../../hooks/useInputValidate'
import MapSelector from './MapSelector'
import { AdminData } from './MapSelectorPopup'
import { APICallGenerateEWMsgRequest, APICallGenerateProcKeyRequest, APICallNewMWARequest, APICallNewWarningRequest, APIRequestAddAreaTypes, APIRequestAddMWAAreaTypes, APIRequestAddMWATypes, APIRequestSelectedSubscribersType, APIRequestWarningAddTypes, APIResponseSelectedSubscribersType, APISaveGroupSubTypes, APIWarningTypeResponseType, ResponseTypes } from '../../services/APIEarlyWarningService'
import AlertDialog from '../popupComp/AlertDialog'
import LoadingScreen from '../loadingScreenComp/LoadingScreen'
import { Department } from '../OrganizationAddUserComp/OrganizationAddUserTypes'
import { useUserData } from '../../context/UserDataContext'
import { APIGetUserAreas } from './CreateWarningService'

import loadLightIcon from '../../images/icons/load-light.gif'
import loadDarkIcon from '../../images/icons/load-dark.gif'
import { useTheme } from '../../context/ThemeContext'
import { APIGetAllCustomSubscribers, Subscriber } from './EarlyWarningService'
import { GetSelectedGroup } from '../warningWorkflowProcessComp/WarningWorkflowProcess'
import { UserDataRow } from '../earlyWarning/emailComp/EmailTypes'
import GroupSelectTable from '../warningWorkflowProcessComp/GroupSelectTable'
import UserSelectTable from '../warningWorkflowProcessComp/UserSelectTable'

type TWWarningPropsType = {
    ewType: APIWarningTypeResponseType;
    username: string;
 }

 interface RowState {
    isSelected: boolean;
    minWind: number;
    maxWind: number;
    minWave: number;
    maxWave: number;
    seaCondition: string;
    thunderstorm: string;
    startDate: string;
    endDate: string;
}

const TWWarning = (props: TWWarningPropsType) => {

    const { theme } = useTheme()

    const { username, areas } = useUserData()

    const BASE_URL = process.env.REACT_APP_BASE_URL
    const COUNTRY = process.env.REACT_APP_COUNTRY

    const { department, contact } = useUserData()
    
    const [departments, setDepartments] = useState<SelectItemTypes[]>([]);
    // Custom hook
    const {validateField} = useInputValidate()

    const [hiddenIslandCodes, setHiddenIslandCodes] = useState<string[]>([])

    const [isLoading, setIsLoading] = useState<boolean>(false)

    const [alertDialogState, setAlertDialogState] = useState(false);
    const [alertTitle, setAlertTitle] = useState('');
    const [alertDescription, setAlertDescription] = useState('');
    const [alertYesCallback, setAlertYesCallback] = useState<(() => void) | undefined>(undefined); // for Yes
    const [alertOkCallback, setAlertOkCallback] = useState<(() => void) | undefined>(undefined);  // for OK

    const showAlertDialog = (
    title: string,
    description: string,
    yesCallback?: () => void,
    okCallback?: () => void
    ) => {
    setAlertTitle(title);
    setAlertDescription(description);
    setAlertYesCallback(() => yesCallback); // Will show Yes/Cancel if defined
    setAlertOkCallback(() => okCallback);   // Will trigger only on OK
    setAlertDialogState(true);
    };

    // Primary cause
    const [twSeaCondition, setTWSeaCondition] = useState<SelectItemTypes[]>([
        {name: "White", value: "white"},
        {name: "Yellow", value: "yellow"},
        {name: "Orange", value: "amber"},
        {name: "Red", value: "red"},
    ])

    // Lightning risk levels
    const [twThunderstorm, setTWThunderstorm] = useState<SelectItemTypes[]>([
        {name: "Low", value: "low"},
        {name: "Moderate", value: "moderate"},
        {name: "High", value: "high"},
    ])

    // Number of rows in table
    const [numberOfRows, setNumberOfRows] = useState<number>(10)
    const numberOfRowsRef = useRef<HTMLInputElement | null>(null)

    // Supportive document
    const [fileName, setFileName] = useState<string>('Upload');
    const fileInputRef = useRef<HTMLInputElement>(null);

    const twNumberRef = useRef<HTMLInputElement | null>(null)
    const twRequestNameRef = useRef<HTMLInputElement | null>(null)
    const twContactNumberRef = useRef<HTMLInputElement | null>(null)
    const twPreRequestDocumentRef = useRef<HTMLInputElement | null>(null)
    const twValidityStartRef = useRef<HTMLInputElement | null>(null)
    const twValidityEndRef = useRef<HTMLInputElement | null>(null)
    const twDateRef = useRef<HTMLInputElement | null>(null)
    const twRequestersDepartmentRef = useRef<HTMLSelectElement | null>(null)
    
    const twTextAreaEnglishRef = useRef<HTMLTextAreaElement | null>(null)
    const twTextAreaDhivehiRef = useRef<HTMLTextAreaElement | null>(null)
    const twTextAreaSinhalaRef = useRef<HTMLTextAreaElement | null>(null)
    const twTextAreaBengaliRef = useRef<HTMLTextAreaElement | null>(null)
    const twReportedLinkRef = useRef<HTMLInputElement | null>(null)

    const twTextAreaCusEnglishRef = useRef<HTMLTextAreaElement | null>(null)
    const twTextAreaCusDhivehiRef = useRef<HTMLTextAreaElement | null>(null)
    const twTextAreaCusSinhalaRef = useRef<HTMLTextAreaElement | null>(null)
    const twTextAreaCusBengaliRef = useRef<HTMLTextAreaElement | null>(null)
    const twTextAreaCusTamilRef = useRef<HTMLTextAreaElement | null>(null)

    const [messagingAreaStatus, setMessageAreaStatus] = useState<boolean>(false)

    const [csvErrors, setCSVErrors] = useState<string | null>(null)
    const [fileCSVName, setFileCSVName] = useState<string>('Upload');
    const fileInputCSVRef = useRef<HTMLInputElement>(null)
    const [csvData, setCSVData] = useState<SubscriberDataType[]>([])

    const csvSubNameRef = useRef<HTMLInputElement | null>(null)

    const subscriberSaveRef = useRef<HTMLInputElement | null>(null)

    const [isCSVDataPikerOpen, setIsCSVDataPikerOpen] = useState<boolean>(false)
    const [isCSVDataPickerLoading, setIsCSVDataPickerLoading] = useState<boolean>(false)

    const mwaWarningIdRef = useRef<HTMLInputElement | null>(null)

    // Area selection status
    const [areaSelectType, setAreaSelectType] = useState<'table' | 'map'>('table')

    const [startDate, setStartDate] = useState<string>('')
    const handleStartDateChange = () => {
        if(twValidityStartRef.current) {
            console.log("data start" ,twValidityStartRef.current.value)
            setStartDate(twValidityStartRef.current.value)
        }
    }

    const [endDate, setEndDate] = useState<string>('')
    const handleEndDateChange = () => {
        if(twValidityEndRef.current) {
            console.log("data end" ,twValidityEndRef.current)
            setEndDate(twValidityEndRef.current.value)
        }
    }

    useEffect(() => {
        if (startDate) {
            setTWTableData(prevData =>
                prevData.map(row => {
                    if (row.type === "TW") {
                        return {
                            ...row,
                            data: {
                                ...row.data,
                                startDate: startDate
                            }
                        };
                    }
                    return row;
                })
            );
        }
    }, [startDate]);

    useEffect(() => {
        if (endDate) {
            setTWTableData(prevData =>
                prevData.map(row => {
                    if (row.type === "TW") {
                        return {
                            ...row,
                            data: {
                                ...row.data,
                                endDate: endDate
                            }
                        };
                    }
                    return row;
                })
            );
        }
    }, [endDate]);

    const dataMap: InputGroupPropsTypes[] = [
        {
            type: 'text',
            icon: <IdIcon width="1.5rem" color="var(--color-main-white)" />,
            color: 'var(--color-accent-bg)',
            placeholder: 'Enter TW Number',
            label: 'TW Number',
            name: 'TWNumber',
            required: true,
            componentInputElement: twNumberRef,
            disabled: true
        },
        {
            type: 'text',
            icon: <IdIcon width="1.5rem" color="var(--color-main-white)" />,
            color: 'var(--color-accent-bg)',
            placeholder: 'Enter Request Name',
            label: 'Request Name',
            name: 'RequestName',
            required: false,
            componentInputElement: twRequestNameRef,
            disabled: true
        },
        {
            type: 'date-time',
            icon: <CalenderIcon width="1.5rem" color="var(--color-main-white)" />,
            color: 'var(--color-accent-bg)',
            placeholder: 'Enter start valid period',
            label: 'validity start time',
            name: 'validityStartTime',
            required: true,
            componentInputElement: twValidityStartRef,
            onChange: handleStartDateChange
        },
        {
            type: 'date-time',
            icon: <CalenderIcon width="1.5rem" color="var(--color-main-white)" />,
            color: 'var(--color-accent-bg)',
            placeholder: 'Enter end valid period',
            label: 'validity end time',
            name: 'validityEndTime',
            required: true,
            componentInputElement: twValidityEndRef,
            onChange: handleEndDateChange
        },
        {
            type: 'text',
            icon: <MobileIcon width="1.5rem" color="var(--color-main-white)" />,
            color: 'var(--color-accent-bg)',
            placeholder: 'Enter Contact number',
            label: 'contact number',
            name: 'contactNumber',
            required: false,
            componentInputElement: twContactNumberRef,
        },
        {
            type: 'text',
            icon: <DocumentIcon width="1.5rem" color="var(--color-main-white)" />,
            color: 'var(--color-accent-bg)',
            placeholder: 'Enter pre-request document',
            label: 'pre-request document',
            name: 'preRequestDocument',
            required: false,
            componentInputElement: twPreRequestDocumentRef,
        },
        {
            type: 'date-time',
            icon: <CalenderIcon width="1.5rem" color="var(--color-main-white)" />,
            color: 'var(--color-accent-bg)',
            placeholder: 'Enter end valid period',
            label: 'TW date',
            name: 'TWDate',
            required: true,
            componentInputElement: twDateRef,
        },
        /* {
            type: 'text',
            icon: <IdIcon width="1.5rem" color="var(--color-main-white)" />,
            color: 'var(--color-accent-bg)',
            placeholder: 'Enter requester\'s department',
            label: 'requester\'s department',
            name: 'requestersDepartment',
            required: false,
            componentInputElement: twRequestersDepartmentRef,
        } */
        {
            type: 'select',
            icon: <DepartmentIcon width="1.5rem" color="var(--color-main-white)" />,
            color: 'var(--color-accent-bg)',
            label: 'requester\'s department',
            name: 'requestersDepartment',
            required: false,
            placeholder: 'Not selected',
            componentSelectElement: twRequestersDepartmentRef,
            optionList: departments,
            disabled: true
        }
    ]

    const [oldAlert, setOldAlert] = useState<ResponseGetActiveWarningDto[]>([])
                    
    useEffect(() => {
            setTWTableData(prevState => {
                const updatedState = [...prevState]
                
                oldAlert.forEach(alertItem => {
                    const index = updatedState.findIndex(item => item.type === "TW" && item.data.code === alertItem.areaCode)
    
                    if (index !== -1) {
                        // Item exists → update only previousAlertLevel
                        const currentItem = updatedState[index];
                        if (currentItem.type === "TW") {
                            updatedState[index] = {
                                ...currentItem,
                                data: {
                                    ...currentItem.data,
                                    prevSeaCondition: alertItem.status || ""
                                }
                            };
                        }
                    } else {
                        // Item does not exist → add new LSW item
                        const newTW: TWAdminData = {
                            code: alertItem.areaCode,
                            name: "",
                            adminName: "",
                            adminLevel: getAdminLevelByCode(alertItem.areaCode),
                            isSelected: true,
                            prevSeaCondition: alertItem.status || "",
                            seaCondition: "",
                            minWindSpeed: 0,
                            maxWindSpeed: 0,
                            minWave: 0,
                            maxWave: 0,
                            thunderstorm: "",
                            startDate: startDate || "",
                            endDate: endDate || ""
                        }
                        updatedState.push({ type: "TW", data: newTW } as AdminData);
                    }
                })
                return updatedState;
            })
        }, [oldAlert])

    useEffect(() => {
        // let department = ''
        // let contact = ""
        // const userJson = sessionStorage.getItem("userdetails");
        // if (userJson) 
        // {
        //     const user = JSON.parse(userJson);
        //     department = user.department
        //     contact = user.mobilenumber
        // }
        const token = localStorage.getItem("access_token");
        fetch(BASE_URL + "/identity_manager/api/v1/getalldepartments", {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
            })
            .then((res) => res.json())
            .then((data) => {
                //console.log("Fetched organizations in Create Org:", data);
                const departmentData: SelectItemTypes[] = []
                data.map((item: Department) => {
                    departmentData.push({value: item.departmentid, name: item.departmentname})
                })
                setDepartments(departmentData)
            })
            .catch((err) => console.error("Error fetching organizations:", err));

        if (twRequestNameRef.current && twDateRef.current && twRequestersDepartmentRef.current && twContactNumberRef.current) 
        {
            twRequestNameRef.current.value = props.ewType.warningId
            twRequestersDepartmentRef.current.value = department
            twContactNumberRef.current.value = contact
            
            const now = new Date();

            const year = now.getFullYear()
            const month = String(now.getMonth() + 1).padStart(2, '0')
            const day = String(now.getDate()).padStart(2, '0')
            const hours = String(now.getHours()).padStart(2, '0')
            const minutes = String(now.getMinutes()).padStart(2, '0')

            // Format: "2025-07-21T14:30"
            const currentDateTime = `${year}-${month}-${day}T${hours}:${minutes}`
            twDateRef.current.value = currentDateTime
        }

        fetch(`${BASE_URL}/ew/api/v1/getCurrentProcess?type=TW`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        })
        .then(response => response.json())
        .then(data => {
            const values = data as ResponseTypes
            const newData = values.data as ResponseGetActiveWarningDto[]
            setOldAlert(newData)
        })
    }, [])

    useEffect(() => {
        // let department = ''
        // const userJson = sessionStorage.getItem("userdetails");
        // if (userJson) 
        // {
        //     const user = JSON.parse(userJson);
        //     department = user.department
        // }

        if (twRequestersDepartmentRef.current) 
        {
            twRequestersDepartmentRef.current.value = department
        }

    }, [departments])

    // Table data row
    //const [tableData, setTableData] = useState<AdministrativeLevels>(sriLankaAdministrationLevel)
    const [selectedCodes, setSelectedCodes] = useState(new Set());
    const [filterTableData, setFilterTableData] = useState<FlatAdmin[]>([])
    const [tableData, setTableData] = useState<FlatAdmin[]>([])
    const [pagination, setPagination] = useState<FlatAdmin[][]>([])
    const [selectedPagination, setSelectedPagination] = useState<number>(0)

    const [rowStates, setRowStates] = useState<Record<string, RowState>>({});
    const [TWTableData, setTWTableData] = useState<AdminData[]>([])
    const TWTableDataRef = useRef<AdminData[]>([])
    const TWObjectRef = useRef<TWDataRefType>({
        twNumber: '',
        requestName: '',
        contactNumber: '',
        preRequestNumber: '',
        validityStartTime: '',
        validityEndTime: '',
        twDate: '',
        requestsDepartment: '',
        adminData: [],
        desEnglish: '',
        desDhivehi: '',
        desSinhala: '',
        desBengali: '',
        reportedLink: '',
        supportDocument: null,
        warningId: '',

        desCusEnglish: '',
        desCusDhivehi: '',
        desCusSinhala: '',
        desCusBengali: '',
        desCusTamil: '',
    })

    const [selectedArea, setSelectedArea] = useState<string[]>([])
    const handleCheckBox = (event: React.ChangeEvent<HTMLInputElement>) => {
        
        if (event.target.checked) {
            setSelectedArea(prevState => [...prevState, event.target.name])
        } else {
            setSelectedArea(prevState => prevState.filter(item => item !== event.target.name))
        }
    }

    // Pagination next prev navigation
    const paginationNavigation = ( side: "next" | "prev") => {
        if (side === "next") {
            if (pagination.length > selectedPagination + 1) {
                setSelectedPagination(prevState => prevState + 1)
            }
           
        } else if (side === "prev") {
            if (0 <= selectedPagination - 1){
                setSelectedPagination(prevState => prevState - 1)
            }
        }
    }

    const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files.length > 0) {
            setFileName(event.target.files[0].name);
            TWObjectRef.current.supportDocument = event.target.files[0]
        } else {
            setFileName('Upload');
        }
    }

    const handleGenerateEWMessageData = async (event: React.MouseEvent<HTMLButtonElement>) => {
        setIsLoading(true)

        const twNumberRefField = validateField(twNumberRef)
        const twDateRefField = validateField(twDateRef)
        const twValidityStartRefField = validateField(twValidityStartRef)
        const twValidityEndRefField = validateField(twValidityEndRef)
        
        if (!twNumberRefField || !twDateRefField || !twValidityStartRefField || !twValidityEndRefField){
            setIsLoading(false)
            return showAlertDialog("Validation Error", "Validation error")
        }

        /* if (areaSelectType === 'table') {
            TWTableDataRef.current = Object.entries(rowStates).map(([code, state]) => ({
                type: 'TW',
                data: {
                    name: tableData.find(item => item.code === code)?.name || "",
                    code,
                    adminName: tableData.find(item => item.code === code)?.adminLevel || "",
                    adminLevel: tableData.find(item => item.code === code)?.adminLevel || "",
                    minWindSpeed: state.minWind,
                    maxWindSpeed: state.maxWind,
                    minWave: state.minWave,
                    maxWave: state.maxWave,
                    seaCondition: state.seaCondition,
                    thunderstorm: state.thunderstorm,
                    startDate: state.startDate || startDate,
                    endDate: state.endDate || endDate
                }
            }))
        } */

        for (const item of TWTableData) {
            const data = item.data as TWAdminData;

            // Check if data.code exists in oldAlert
            const existsInOldAlert = oldAlert.some(alert => alert.areaCode === data.code);
            //console.log("VALIDATE ", existsInOldAlert)
            if (!data.seaCondition && !existsInOldAlert) {
                showAlertDialog(
                    "Validation Error",
                    "New alert level must be selected in all selected locations"
                );
                setIsLoading(false);
                return
        }}

        if (TWObjectRef.current) 
        {
            if(twNumberRef.current && twRequestNameRef.current && twContactNumberRef.current && twPreRequestDocumentRef.current && twValidityStartRef.current && twValidityEndRef.current && twDateRef.current && twRequestersDepartmentRef.current && TWTableDataRef.current && twTextAreaEnglishRef.current && twTextAreaDhivehiRef.current && twReportedLinkRef.current && fileInputRef.current && csvSubNameRef.current && subscriberSaveRef.current) 
            {
                TWObjectRef.current.twNumber = twNumberRef.current.value
                TWObjectRef.current.requestName = twRequestNameRef.current.value
                TWObjectRef.current.contactNumber = twContactNumberRef.current.value
                TWObjectRef.current.preRequestNumber = twPreRequestDocumentRef.current.value
                TWObjectRef.current.validityStartTime = twValidityStartRef.current.value
                TWObjectRef.current.validityEndTime = twValidityEndRef.current.value
                TWObjectRef.current.twDate = twDateRef.current.value
                TWTableData.map(item => {
                    const data = item.data as TWAdminData
                    const existOnOldAlert = oldAlert.some(alert => alert.areaCode === data.code)

                    if (existOnOldAlert && !data.seaCondition) return
                    TWObjectRef.current.adminData.push(item.data as TWAdminData)
                })
                //MWAObjectRef.current.adminData = MWATableDataRef.current
                TWObjectRef.current.desEnglish = twTextAreaEnglishRef.current.value

                if (COUNTRY === "SRI_LANKA" && twTextAreaSinhalaRef.current)
                {
                    TWObjectRef.current.desSinhala = twTextAreaSinhalaRef.current.value
                }
    
                if (COUNTRY === "MALDIVES" && twTextAreaBengaliRef.current)
                {
                    TWObjectRef.current.desBengali = twTextAreaBengaliRef.current.value
                }
                
                TWObjectRef.current.reportedLink = twReportedLinkRef.current.value
                TWObjectRef.current.warningId = props.ewType.warningId

                const twData: TWDataRefType = TWObjectRef.current
                const twAdminData: APIRequestAddAreaTypes[] = []
        
                twData.adminData.map(area => {
                    const newAdmin: APIRequestAddAreaTypes = {
                        code: area.code,
                        administrationName: area.adminName,
                        administrationLevel: area.adminLevel,
                        minWind: area.minWindSpeed,
                        maxWind: area.maxWindSpeed,
                        minWave: area.minWave,
                        maxWave: area.maxWave,
                        previousAlertLevel: area.prevSeaCondition,
                        seaCondition: area.seaCondition,
                        thunderstorm: area.thunderstorm,
                        startDate: convertToOffsetDateTime(area.startDate),
                        endDate: convertToOffsetDateTime(area.endDate)
                    }
                    twAdminData.push(newAdmin)
                })

                const TWNewRequestBody: APIRequestWarningAddTypes = {
                    triggerType: "ADV",
                    type: 'TW',
                    warningNumber: twData.twNumber,
                    requestName: twData.requestName,
                    contactNumber: twData.contactNumber,
                    preRequestDocument: twData.preRequestNumber,
                    validityStartTime: convertToOffsetDateTime(twData.validityStartTime),
                    validityEndTime: convertToOffsetDateTime(twData.validityEndTime),
                    warningDate: convertToOffsetDateTime(twData.twDate),
                    requestersDepartment: twData.requestsDepartment,
                    effectedAreas: twAdminData,
                    messageBodyEnglish: twData.desEnglish,
                    messageBodyDhivehi: twData.desDhivehi,
                    messageBodySinhala: twData.desSinhala,
                    messageBodyBengali: twData.desBengali,
                    reportLink: twData.reportedLink,
                    supportiveDocument: twData.supportDocument,
                    warningId: twData.warningId,
                    csvData: csvData,
                    isCsvSave: subscriberSaveRef.current.checked,
                    csvName: csvSubNameRef.current.value === '' || csvSubNameRef.current.value === null ? fileCSVName.split('.')[0] : csvSubNameRef.current.value,

                    messageCusBodyEnglish: twData.desCusEnglish,
                    messageCusBodyDhivehi: twData.desCusDhivehi,
                    messageCusBodySinhala: twData.desCusSinhala,
                    messageCusBodyBengali: twData.desCusBengali,
                    messageCusBodyTamil: twData.desCusTamil,
                    
                }
                //console.log("________>>> ", TWNewRequestBody)
                try {
                    const response = await APICallGenerateEWMsgRequest(TWNewRequestBody)

                    if (!response.errorCode) 
                    {
                        //console.log(response);

                        if (twTextAreaEnglishRef.current && twTextAreaDhivehiRef.current) {
                            // After got response set to field
                            twTextAreaEnglishRef.current.value = response.data.ew_generalMsgLanBase // English data in response
                            twTextAreaDhivehiRef.current.value =response.data.ew_generalMsgLanDV // Dhivehi data in response

                            if (COUNTRY === "SRI_LANKA" && twTextAreaSinhalaRef.current)
                            {
                                twTextAreaSinhalaRef.current.value = response.data.ew_generalMsgLanSI // Sinhala data in response
                            }
                
                            if (COUNTRY === "MALDIVES" && twTextAreaBengaliRef.current)
                            {
                                twTextAreaBengaliRef.current.value = response.data.ew_generalMsgLanBN // Bengali data in response
                            }
                        } 
                    }
                    else {
                        switch (response.errorCode) 
                        {
                            case 1010:
                                console.log("❌ ", response.errorMessage);
                                showAlertDialog("Unauthorized", "❌ Unauthorized request");
                                break
                            default:
                                console.log("❌ ", response.errorMessage);
                                showAlertDialog("Error", "❌ Error adding data");
                        }

                    }
                }
                catch (ex) {
                    console.error("❌ Tsunami warning submit exception:", ex);
                    showAlertDialog("Submit Error", "❌ Tsunami warning submit exception");
                }
            }
            
        }
        setIsLoading(false)
    }

    // Handle save data
    const handleSaveClick = async (event: React.MouseEvent<HTMLButtonElement>) => {
        setIsLoading(true)

        const twNumberRefField = validateField(twNumberRef)
        const twDateRefField = validateField(twDateRef)
        const twValidityStartRefField = validateField(twValidityStartRef)
        const twValidityEndRefField = validateField(twValidityEndRef)
        
        if (!twNumberRefField || !twDateRefField || !twValidityStartRefField || !twValidityEndRefField){
            setIsLoading(false)
            return showAlertDialog("Validation Error", "Validation error")
        }

        /* if (areaSelectType === 'table') {
            TWTableDataRef.current = Object.entries(rowStates).map(([code, state]) => ({
                type: 'TW',
                data: {
                    name: tableData.find(item => item.code === code)?.name || "",
                    code,
                    adminName: tableData.find(item => item.code === code)?.adminLevel || "",
                    adminLevel: tableData.find(item => item.code === code)?.adminLevel || "",
                    minWindSpeed: state.minWind,
                    maxWindSpeed: state.maxWind,
                    minWave: state.minWave,
                    maxWave: state.maxWave,
                    seaCondition: state.seaCondition,
                    thunderstorm: state.thunderstorm,
                    startDate: state.startDate || startDate,
                    endDate: state.endDate || endDate
                }
            }))
        } */

        for (const item of TWTableData) {
            const data = item.data as TWAdminData;

            // Check if data.code exists in oldAlert
            const existsInOldAlert = oldAlert.some(alert => alert.areaCode === data.code);
            //console.log("VALIDATE ", existsInOldAlert)
            if (!data.seaCondition && !existsInOldAlert) {
                showAlertDialog(
                    "Validation Error",
                    "New alert level must be selected in all selected locations"
                );
                setIsLoading(false);
                return
        }}

        if (TWObjectRef.current) 
        {
            if(twNumberRef.current && twRequestNameRef.current && twContactNumberRef.current && twPreRequestDocumentRef.current && twValidityStartRef.current && twValidityEndRef.current && twDateRef.current && twRequestersDepartmentRef.current && TWTableDataRef.current && twTextAreaEnglishRef.current && twTextAreaDhivehiRef.current && twReportedLinkRef.current && fileInputRef.current && csvSubNameRef.current && subscriberSaveRef.current && twTextAreaCusEnglishRef.current) 
            {
                TWObjectRef.current.twNumber = twNumberRef.current.value
                TWObjectRef.current.requestName = twRequestNameRef.current.value
                TWObjectRef.current.contactNumber = twContactNumberRef.current.value
                TWObjectRef.current.preRequestNumber = twPreRequestDocumentRef.current.value
                TWObjectRef.current.validityStartTime = twValidityStartRef.current.value
                TWObjectRef.current.validityEndTime = twValidityEndRef.current.value
                TWObjectRef.current.twDate = twDateRef.current.value
                TWTableData.map(item => {
                    const data = item.data as TWAdminData
                    const existOnOldAlert = oldAlert.some(alert => alert.areaCode === data.code)

                    if (existOnOldAlert && !data.seaCondition) return
                    TWObjectRef.current.adminData.push(item.data as TWAdminData)
                })
                //MWAObjectRef.current.adminData = MWATableDataRef.current
                TWObjectRef.current.desEnglish = twTextAreaEnglishRef.current.value
                TWObjectRef.current.desCusEnglish = twTextAreaCusEnglishRef.current.value

                TWObjectRef.current.desDhivehi = twTextAreaDhivehiRef.current.value
                TWObjectRef.current.desDhivehi = twTextAreaDhivehiRef.current.value
                
                if (COUNTRY === "SRI_LANKA" && twTextAreaSinhalaRef.current)
                {
                    TWObjectRef.current.desSinhala = twTextAreaSinhalaRef.current.value
                }
    
                if (COUNTRY === "MALDIVES" && twTextAreaBengaliRef.current && twTextAreaCusBengaliRef.current)
                {
                    TWObjectRef.current.desBengali = twTextAreaBengaliRef.current.value
                    TWObjectRef.current.desCusBengali = twTextAreaCusBengaliRef.current.value
                }

                TWObjectRef.current.reportedLink = twReportedLinkRef.current.value
                TWObjectRef.current.warningId = props.ewType.warningId

                const twData: TWDataRefType = TWObjectRef.current
                                                        
                const twAdminData: APIRequestAddAreaTypes[] = []
        
                twData.adminData.map(area => {
                    const newAdmin: APIRequestAddAreaTypes = {
                        code: area.code,
                        administrationName: area.adminName,
                        administrationLevel: area.adminLevel,
                        minWind: area.minWindSpeed,
                        maxWind: area.maxWindSpeed,
                        minWave: area.minWave,
                        maxWave: area.maxWave,
                        previousAlertLevel: area.prevSeaCondition,
                        seaCondition: area.seaCondition,
                        thunderstorm: area.thunderstorm,
                        startDate: convertToOffsetDateTime(area.startDate),
                        endDate: convertToOffsetDateTime(area.endDate)
                    }
                    twAdminData.push(newAdmin)
                })
        
                const TWNewRequestBody: APIRequestWarningAddTypes = {
                    triggerType: "ADV",
                    type: 'TW',
                    warningNumber: twData.twNumber,
                    requestName: twData.requestName,
                    contactNumber: twData.contactNumber,
                    preRequestDocument: twData.preRequestNumber,
                    validityStartTime: convertToOffsetDateTime(twData.validityStartTime),
                    validityEndTime: convertToOffsetDateTime(twData.validityEndTime),
                    warningDate: convertToOffsetDateTime(twData.twDate),
                    requestersDepartment: twData.requestsDepartment,
                    effectedAreas: twAdminData,
                    messageBodyEnglish: twData.desEnglish,
                    messageBodyDhivehi: twData.desDhivehi,
                    messageBodySinhala: twData.desSinhala,
                    messageBodyBengali: twData.desBengali,
                    reportLink: twData.reportedLink,
                    supportiveDocument: twData.supportDocument,
                    warningId: twData.warningId,
                    csvData: csvData,
                    isCsvSave: subscriberSaveRef.current.checked,
                    csvName: csvSubNameRef.current.value === '' || csvSubNameRef.current.value === null ? fileCSVName.split('.')[0] : csvSubNameRef.current.value,

                    messageCusBodyEnglish: twData.desCusEnglish,
                    messageCusBodyDhivehi: twData.desCusDhivehi,
                    messageCusBodySinhala: twData.desCusSinhala,
                    messageCusBodyBengali: twData.desCusBengali,
                    messageCusBodyTamil: twData.desCusTamil,
                }
        
                // Send request
                try
                {
                    const response = await APICallNewWarningRequest(TWNewRequestBody)
                    
                    if (!response.errorCode)
                    {
                        console.log("✅ Tsunami warning submitted successfully");
                        showAlertDialog("Success", "✅ Tsunami warning submitted successfully!", undefined, () => window.location.reload());
                    } 
                    else 
                    {
                        switch (response.errorCode) {
                            case 1010:
                                console.log("❌ ", response.errorMessage);
                                showAlertDialog("Unauthorized", "❌ Unauthorized request");
                                break
                            default:
                                console.log("❌ ", response.errorMessage);
                                showAlertDialog("Error", "❌ Error adding data");
                        }
                        
                    }
                } 
                catch (ex)
                {
                    console.error("❌ Tsunami warning submit exception:", ex);
                    showAlertDialog("Submit Error", "❌ Tsunami warning submit exception");
                }
            }
        }
        setIsLoading(false)
    }

    // Selected country
    const country = process.env.REACT_APP_COUNTRY

    const [allowedAreas, setAllowedAreas] = useState<string[]>([])
    useEffect(() => {
        // const getUserAreas = async () => {
        //     const response = await APIGetUserAreas()
        //     //console.log('AREAS ->', response.data)
        //     if (!response)
        //     {
        //         showAlertDialog('Error', '❌ data loading failed')
        //     }
            
        //     setAllowedAreas(response.data)

        //     if (country === "SRI_LANKA") {
        //         const flat = flatMap(sriLankaAdministrationLevel, selectedArea)
        //         setTableData(flat)
        //         setFilterTableData(flat)
        //     } else if (country === "MALDIVES") {
        //         const flat = flatMap({...maldivesAdministrativeLevel, ...maldivesSeaAdministrativeLevel}, selectedArea)
        //         const flatSea = flatMap({...maldivesSeaAdministrativeLevel, ...maldivesSeaAdministrativeLevel}, selectedArea)
        //         const final = [...flat, ...flatSea]
        //         const filtered: FlatAdmin[] = final.filter(item => response.data.some(code => item.code.startsWith(code)))
        //         setTableData(filtered)
        //         setFilterTableData(filtered)
        //     }
        // }
        // getUserAreas()

        setAllowedAreas(areas)
        
        if (country === "SRI_LANKA") {
            const flat = flatMap(sriLankaAdministrationLevel, selectedArea)
            setTableData(flat)
            setFilterTableData(flat)
        } else if (country === "MALDIVES") {
            const flat = flatMap(maldivesAdministrativeLevel, selectedArea)
            const flatSea = flatMap({...maldivesSeaAdministrativeLevel, ...maldivesSeaAdministrativeLevel}, selectedArea)

            const filtered: FlatAdmin[] = flat.filter(item => areas.some(code => item.code.startsWith(code)))
            const filteredSea: FlatAdmin[] = flatSea.filter(item => areas.some(code => item.code.startsWith(code)))

            const final = [...filtered, ...filteredSea]

            setTableData(final)
            setFilterTableData(final)
        }
    }, [])

    useEffect(() => {
        setPagination(paginationList(filterTableData, numberOfRows))
    }, [tableData, filterTableData, numberOfRows])

    // Handle table search
    const handelSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
        if (event.target.value === "") {
            setFilterTableData(tableData)
        } else {
            setFilterTableData(tableData.filter(item => item.name.toLowerCase().includes(event.target.value.toLowerCase())))
        }
    }

    const handleTWMinWind = (event: ChangeEvent<HTMLInputElement>) => {
        const code = event.target.name;
        const value = parseFloat(event.target.value) || 0;
        
        // Update row states
        /* setRowStates(prev => ({
            ...prev,
            [code]: {
                ...prev[code],
                minWind: value
            }
        }));

    
        TWTableDataRef.current = TWTableDataRef.current.map(item => {
            if (item.type === 'TW' && item.data.code === code) {
                return {
                    ...item,
                    data: {
                        ...item.data,
                        minWindSpeed: value
                    }
                };
            }
            return item;
        }); */
        setTWTableData(prevData =>
            prevData.map(row => {
                if (row.type === "TW" && row.data.code === code) {
                    return {
                        ...row,
                        data: {
                            ...row.data,
                            minWindSpeed: value
                        }
                    };
                }
                return row;
            })
        )
    }

    const handleTWMaxWind = (event: ChangeEvent<HTMLInputElement>) => {
        const code = event.target.name;
        const value = parseFloat(event.target.value) || 0;
        
        // Update row states
        /* setRowStates(prev => ({
            ...prev,
            [code]: {
                ...prev[code],
                maxWind: value
            }
        }));

        // Update the FLWTableDataRef immutably
        TWTableDataRef.current = TWTableDataRef.current.map(item => {
            if (item.type === 'TW' && item.data.code === code) {
                return {
                    ...item,
                    data: {
                        ...item.data,
                        maxWindSpeed: value
                    }
                };
            }
            return item;
        }); */
        setTWTableData(prevData =>
            prevData.map(row => {
                if (row.type === "TW" && row.data.code === code) {
                    return {
                        ...row,
                        data: {
                            ...row.data,
                            maxWindSpeed: value
                        }
                    };
                }
                return row;
            })
        )
    }

    const handleTWMinWave = (event: ChangeEvent<HTMLInputElement>) => {
        const code = event.target.name;
        const value = parseFloat(event.target.value) || 0;
        
        // Update row states
        /* setRowStates(prev => ({
            ...prev,
            [code]: {
                ...prev[code],
                minWave: value
            }
        }));

    
        TWTableDataRef.current = TWTableDataRef.current.map(item => {
            if (item.type === 'TW' && item.data.code === code) {
                return {
                    ...item,
                    data: {
                        ...item.data,
                        minWave: value
                    }
                };
            }
            return item;
        }); */
        setTWTableData(prevData =>
            prevData.map(row => {
                if (row.type === "TW" && row.data.code === code) {
                    return {
                        ...row,
                        data: {
                            ...row.data,
                            minWave: value
                        }
                    };
                }
                return row;
            })
        )
    }
    
    const handleTWMaxWave = (event: ChangeEvent<HTMLInputElement>) => {
        const code = event.target.name;
        const value = parseFloat(event.target.value) || 0;
        
        // Update row states
        /* setRowStates(prev => ({
            ...prev,
            [code]: {
                ...prev[code],
                maxWave: value
            }
        }));

        // Update the FLWTableDataRef immutably
        TWTableDataRef.current = TWTableDataRef.current.map(item => {
            if (item.type === 'TW' && item.data.code === code) {
                return {
                    ...item,
                    data: {
                        ...item.data,
                        maxWave: value
                    }
                };
            }
            return item;
        }); */
        setTWTableData(prevData =>
            prevData.map(row => {
                if (row.type === "TW" && row.data.code === code) {
                    return {
                        ...row,
                        data: {
                            ...row.data,
                            maxWave: value
                        }
                    };
                }
                return row;
            })
        )
    }

    const handleTWPrevSeaCondition = (event: ChangeEvent<HTMLSelectElement>) => {
        const code = event.target.name;
        const value = event.target.value;
        /* setRowStates(prev => ({
            ...prev,
            [code]: {
            ...prev[code],
            seaCondition: event.target.value
            }
        })); */
        setTWTableData(prevData =>
            prevData.map(row => {
                if (row.type === "TW" && row.data.code === code) {
                    return {
                        ...row,
                        data: {
                            ...row.data,
                            prevSeaCondition: value
                        }
                    };
                }
                return row;
            })
        )
    };

    const handleTWSeaCondition = (event: ChangeEvent<HTMLSelectElement>) => {
        const code = event.target.name;
        const value = event.target.value;
        /* setRowStates(prev => ({
            ...prev,
            [code]: {
            ...prev[code],
            seaCondition: event.target.value
            }
        })); */
        setTWTableData(prevData =>
            prevData.map(row => {
                if (row.type === "TW" && row.data.code === code) {
                    return {
                        ...row,
                        data: {
                            ...row.data,
                            seaCondition: value
                        }
                    };
                }
                return row;
            })
        )
    };

    const handleTWThunderstorm = (event: ChangeEvent<HTMLSelectElement>) => {
        const code = event.target.name;
        const value = event.target.value;
        /* setRowStates(prev => ({
            ...prev,
            [code]: {
            ...prev[code],
            thunderstorm: event.target.value
            }
        })); */
        setTWTableData(prevData =>
            prevData.map(row => {
                if (row.type === "TW" && row.data.code === code) {
                    return {
                        ...row,
                        data: {
                            ...row.data,
                            thunderstorm: value
                        }
                    };
                }
                return row;
            })
        )
    };

    const handleTWStartDate = (event: ChangeEvent<HTMLInputElement>) => {
        const code = event.target.name;
        const value = event.target.value;
        /* setRowStates(prev => ({
            ...prev,
            [code]: {
            ...prev[code],
            startDate: event.target.value
            }
    })); */
    setTWTableData(prevData =>
            prevData.map(row => {
                if (row.type === "TW" && row.data.code === code) {
                    return {
                        ...row,
                        data: {
                            ...row.data,
                            endDate: value
                        }
                    };
                }
                return row;
            })
        )
    };
        
    const handleTWEndDate = (event: ChangeEvent<HTMLInputElement>) => {
        const code = event.target.name;
        const value = event.target.value;
        /* setRowStates(prev => ({
            ...prev,
            [code]: {
            ...prev[code],
            endDate: event.target.value
            }
        })); */
    };
    
    const getAllChildIslandCodes = (level: AdministrativeLevel): string[] => {
        if (!level.children) return [];

        const codes: string[] = [];
        Object.entries(level.children).forEach(([code, child]) => {
            if (child.adminLevel === 'island') {
                codes.push(code);
            }

            // Recurse deeper
            codes.push(...getAllChildIslandCodes(child));
        });

        return codes;
    }

    const findAdminByCode = (levels: AdministrativeLevels, code: string): AdministrativeLevel | null => {
        for (const [key, level] of Object.entries(levels)) {
            if (key === code) return level;
            if (level.children) {
            const result = findAdminByCode(level.children, code);
            if (result) return result;
            }
        }
        return null;
    }

    useEffect(() => {
        const visibleData = filterTableData.filter(item => !hiddenIslandCodes.includes(item.code));
        const paginated = paginationList(visibleData, numberOfRows);
        setPagination(paginated);

        // Reset to first page if current page is out of bounds after filtering
        if (selectedPagination >= paginated.length) {
            setSelectedPagination(0);
        }
    }, [filterTableData, numberOfRows, hiddenIslandCodes])

    // Handle check box click
    const handleCheckBoxClick = (event: ChangeEvent<HTMLInputElement>) => {
        handleCheckBox(event);

        const code = event.target.name;
        const isChecked = event.target.checked;

        /* setRowStates(prev => {
            const newState = { ...prev };
            if (isChecked && !newState[code]) {
            newState[code] = {
                isSelected: true,
                minWind: 0,
                maxWind: 0,
                minWave: 0,
                maxWave: 0,
                seaCondition: '',
                thunderstorm: '',
                startDate: startDate || "",
                endDate: endDate || ""
            };
            } else if (!isChecked) {
            delete newState[code];
            }
            return newState;
        }); */

        // Determine which admin structure to use
        const adminSource = country === 'SRI_LANKA' ? sriLankaAdministrationLevel : maldivesAdministrativeLevel;

        // Find the clicked admin level (atoll or island)
        const clickedAdminLevel = findAdminByCode(adminSource, code);

        // If it's an atoll, toggle island visibility
        if (clickedAdminLevel && clickedAdminLevel.adminLevel === 'atoll') {
        const childIslandCodes = getAllChildIslandCodes(clickedAdminLevel);
        setHiddenIslandCodes(prev =>
            isChecked
            ? [...prev, ...childIslandCodes] // hide children
            : prev.filter(code => !childIslandCodes.includes(code)) // show again
        );
        }

        /* setSelectedCodes(prev => {
            const updated = new Set(prev);
            if (event.target.checked) {
                updated.add(event.target.name);
            } else {
                updated.delete(event.target.name);
            }
            return updated;
        }); */

        if (event.target.checked) {
            //const alreadyExists = LSWTableDataRef.current.some(item => item.type === 'LSW' && item.data.code === event.target.name)
            const alreadyExists = TWTableData.some(item => item.type === 'TW' && item.data.code === event.target.name)
            
            if (!alreadyExists) 
            {
                console.log("Already exists")
                const data = tableData.find(obj => obj.code === event.target.name);
                if (data) {
                    /*  LSWTableDataRef.current.push({
                        type: 'LSW',
                        data: {
                            isSelected: true,
                            name: data.name,
                            code: data.code,
                            adminName: data.adminLevel,
                            adminLevel: data.adminLevel,
                            newAlertLevel: "",
                            previousAlertLevel: "",
                            lightingRiskLevel: "",
                            rainfall: 0,
                            startDate: lswValidityStartRef.current?.value || '',
                            endDate: lswValidityEndRef.current?.value || ''
                        }
                    }) */

                    setTWTableData(prevState => {
                        return [...prevState, {
                            type: 'TW',
                            data: {
                                isSelected: true,
                                name: data.name,
                                code: data.code,
                                adminName: data.adminLevel,
                                adminLevel: data.adminLevel,
                                minWindSpeed: 0,
                                maxWindSpeed: 0,
                                minWave: 0,
                                maxWave: 0,
                                thunderstorm: "",
                                prevSeaCondition: "",
                                seaCondition: "",
                                startDate: twValidityStartRef.current?.value || startDate,
                                endDate: twValidityEndRef.current?.value || endDate
                            }
                        }]
                    })
                }
            }
        } else {
            setTWTableData(prevState => prevState.filter(item => !(item.type === 'TW' && item.data.code === event.target.name)))
        }
    }

    // Handle Row number change
    const handleRowNumberChanged = (event: ChangeEvent<HTMLInputElement>) => {
        setNumberOfRows(event.target.valueAsNumber)
    }

    const handleTableClick = () => {
        //setSelectedCodes(new Set())
        //TWTableDataRef.current = []
        //setRowStates({})
        setSelectedArea([])
        setAreaSelectType('table')
    }

    const handleMapClick = () => {
        //setSelectedCodes(new Set())
        //TWTableDataRef.current = []
        //setRowStates({})
        setSelectedArea([])
        setAreaSelectType('map')
    }

    useEffect(() => {
            const fetchInitialData = async () => {
                try {
                    const response = await APICallGenerateProcKeyRequest(props.ewType.warningId); // Pass prop here
                    if (response && !response.errorCode) {
                        //console.log("✅ API data loaded: ", response);
                        // Example: store a process key in state
                        // setProcKey(response.processKey);
    
                        if (twNumberRef.current) {
                            twNumberRef.current.value = response.data;
                        }
    
                    } else {
                        console.warn("⚠️ API returned an error:", response?.errorMessage);
                        showAlertDialog("Error", "Failed to load initial data");
                    }
                } catch (error) {
                    console.error("❌ Error fetching data:", error);
                    showAlertDialog("Network Error", "Failed to fetch initial data.");
                }
            };
    
            fetchInitialData();
        }, [props.ewType]);
        
    const handleCSVFileChange = (event: ChangeEvent<HTMLInputElement>) => {
        setCSVErrors(null)
        if (event.target.files && event.target.files.length > 0) {
            setFileCSVName(event.target.files[0].name)
            const file = event.target.files[0]
            
            // Validate File Extension
            if (!file.name.endsWith('.csv'))
            {
                setCSVErrors("Invalid file type. Please upload a CSV file.")
                event.target.value = ''
                return
            }
            else
            {
                setFileCSVName(file.name)
                
                const reader = new FileReader()

                reader.onload = (e) => {

                    const text = e.target?.result as string

                    if (!validateCSVFormat(text).valid)
                    {
                        setCSVErrors("Invalid CSV format. Please upload a CSV file with the correct format.")
                        event.target.value = ''
                        return
                    }

                    const parsedData = parseCSVManually(text)
                    setCSVData(parsedData)
                }

                reader.onerror = () => {
                    setCSVErrors("Error reading CSV file. Please try again.")
                }
                
                reader.readAsText(file)
            }
        } else {
            setFileCSVName('Upload');
        }
    }

    const clearCSV = () => {
        if (!fileInputCSVRef.current) return

        fileInputCSVRef.current.value = ''
        setFileCSVName('Upload')
        setCSVData([])
        setCSVErrors(null)
    }

    const handleClickSaveAndSubmit = (event: React.MouseEvent<HTMLButtonElement>) => {
        if (csvErrors !== null)
        {
            showAlertDialog("CSV Error", "Loaded CSV file detected error. Please fix CSV error before submit. if submit without fix CSV error, CSV data will not be uploaded. Do you need to proceed?", () => handleSaveClick(event), undefined)
        }
        else
        {
            showAlertDialog("Confirm Submit", "Are you sure you want to submit this early warning?", () => handleSaveClick(event), undefined)
        }
    }

    const handleClearCSV = () => {
        setCSVErrors(null)
        setFileCSVName('Upload')
        setCSVData([])
    }

    const existingCSVDataRef = useRef<string[]>([])
    const existingCSVDataSetRef = useRef<SubscriberDataType[]>([])
    const [existingCSVFilterData, setExistingCSVFilterData] = useState<string[]>([])

    // existing data change handle
    const handleChangeExistingDataSearch = (event: ChangeEvent<HTMLInputElement>): void => {
        if (event.target.value === "") 
        {
            setExistingCSVFilterData(existingCSVDataRef.current);
        } 
        else 
        {
            setExistingCSVFilterData(
                existingCSVDataRef.current.filter((item) =>
                    item.toLowerCase().includes(event.target.value.toLowerCase())
                )
            );
        }
    }

    useEffect(() => {
        const fetchExistingCSVData = async () => {
            setIsCSVDataPickerLoading(true)
            const response = await APIGetAllCustomSubscribers(props.ewType.warningId)

            if (!response.status)
            {

            }
            const tempData: SubscriberDataType[] = []
            const tempFileNames: string[] = []

            response.data?.map(item => {
                tempFileNames.push(item.name)
                item.subscribers.map((subscriber: Subscriber) => {
                    const sub: SubscriberDataType = {
                        name: item.name,
                        whatsappContact: subscriber.whatsappContact,
                        whatsapp: subscriber.whatsapp,
                        smsContact: subscriber.smsContact,
                        sms: subscriber.sms,
                        viberContact: subscriber.viberContact,
                        viber: subscriber.viber,
                        email: subscriber.email
                    }
                    tempData.push(sub)
                })
            })
            existingCSVDataSetRef.current = tempData
            existingCSVDataRef.current = tempFileNames
            setExistingCSVFilterData(tempFileNames)
        }

        fetchExistingCSVData()
        setIsCSVDataPickerLoading(false)
    }, [])

    const handleClickFilteredCSV = (sub: string): void => {
        setCSVData(existingCSVDataSetRef.current.filter(item => item.name === sub))
        setCSVErrors(null)
        csvSubNameRef.current!.value = sub
        setFileCSVName(sub)
        setIsCSVDataPikerOpen(false)
    }

    // Selected groups
    const [selectedGroups, setSelectedGroups] = useState<GetSelectedGroup[]>([])
    // Selected user
    const [selectedSubscribers, setSelectedSubscribers] = useState<UserDataRow[]>([])

    const setSubscribersFromApi = (apiSubscribers: APIResponseSelectedSubscribersType[]): UserDataRow[] => {
            return apiSubscribers.map((item) => ({
                isEditable: item.addUser === username ? true : false,
                id: item.id.userId,
                firstName: '',
                lastName: '',
                email: '',
                sms: item.sms,
                whatsapp: item.whatsapp,
                viber: item.viber
            }))
        }

    useEffect(() => {

        if(!twRequestNameRef.current) return
        // Get selected groups
        const getAllSelectedGroups = () => {
            const token = localStorage.getItem("access_token") || "";
            fetch(`${BASE_URL}/ew/api/v1/getSelectedGroups?warningCatCode=${twRequestNameRef.current?.value}`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            })
            .then((res) => res.json())
            .then((data) => {
                const response = data as ResponseTypes
                //console.log(">>>>>>> data: ", data)
                setSelectedGroups(response.data as GetSelectedGroup[])
            })
            .catch((err) => console.error("Error fetching roles:", err));
        };
    
        // Get selected groups
        const getAllSelectedSubscribers = () => {
            const token = localStorage.getItem("access_token") || "";
            fetch(`${BASE_URL}/ew/api/v1/getSelectedSubscribers?warningCatCode=${twRequestNameRef.current?.value}`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            })
            .then((res) => res.json())
            .then((data) => {
                const response = data as ResponseTypes
                //console.log(">>>>>>> subs: ", response.data)

                setSelectedSubscribers(response.data ? setSubscribersFromApi(response.data as APIResponseSelectedSubscribersType[]) : [])
            })
            .catch((err) => console.error("Error fetching roles:", err));
        };

        getAllSelectedGroups()
        getAllSelectedSubscribers()
    }, [])

    const getSubscribersId = (): APIRequestSelectedSubscribersType[] => {
        let result: APIRequestSelectedSubscribersType[] = []
    
        selectedSubscribers.map((item) => {
            const newSubscriber: APIRequestSelectedSubscribersType = {
                userId: item.id,
                sms: item.sms,
                whatsapp: item.whatsapp,
                viber: item.viber
            }
            result.push(newSubscriber)
        })
    
        return result
    }

    const getGroupIdList = (groups: GetSelectedGroup[])  => {
        const data: string[] = []
        groups.map(item => (data.push(item.groupId)))
        return data
    }

    const reloadPage = () => {
        //window.location.reload()
    }

    const handleSaveSubscribersAndGroupButtonClick = () => {
        setIsLoading(true)

        if (!twNumberRef.current || !twRequestNameRef.current) return
        const token = localStorage.getItem("access_token");
        if (!token) {
            throw new Error("Missing access token");
        }

        const body: APISaveGroupSubTypes = {
            selectedGroups: getGroupIdList(selectedGroups),
            selectedSubscribers: getSubscribersId(),
            warningId: twNumberRef.current.value,
            workflowId: twRequestNameRef.current.value

        }

        fetch(`${BASE_URL}/ew/api/v1/saveGroupAndSubscribers`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(body)
        })
        .then((res) => res.json())
        .then((data) => {
            const response = data as ResponseTypes

            if (response.httpStatus === 'OK'){
                setIsLoading(false)
                showAlertDialog("Success", "✅ Groups and subscribers saved successfully", undefined, () => reloadPage());
            }
        })
        .catch((err) => {
            setIsLoading(false)
            console.error("Error fetching roles:", err)
            showAlertDialog("Error", "❌ Groups and subscribers saving failed", undefined, () => reloadPage())
        })
        .finally(() => {
            setIsLoading(false)
        })
    }

    

    return (
        <div>
            <div className='details-selector-wrapper'>
                <div className='title'>
                    <span>Early Warning Details ({props.ewType.warningName})</span>
                </div>
                <div className='details-selector-wrapper-container' style={{backgroundColor: 'transparent'}}>
                    <div className={`left-side`}>
                        {dataMap.slice(0, sideFieldCount(dataMap.length)).map((field, index) => (
                            <InputGroup key={index} {...field}/>
                        ))}
                    </div>

                    <div className={`right-side`}>
                        {dataMap.slice(sideFieldCount(dataMap.length)).map((field, index) => (
                            <InputGroup key={index} {...field}/>
                        ))}
                    </div>
                </div>
            </div>
            <div className='details-selector-wrapper'>
                <div className='title'>
                    <span>Early Warning Details (Area Selection)</span>
                </div>
                <div className='tab-button-wrapper'>
                    <span style={{backgroundColor: areaSelectType === 'table' ? 'var(--color-warning-table-bg)' : 'var(--color-container-form-bg)'}} onClick={() => handleTableClick()}>table view mode</span>
                    <span style={{backgroundColor: areaSelectType === 'map' ? 'var(--color-warning-table-bg)' : 'var(--color-container-form-bg)'}} onClick={() => handleMapClick()}>map view mode</span>
                </div>
                {areaSelectType === 'table' && (
                    <div className='details-selector-wrapper-table-container'>
                        <div className='area-table-wrapper'>
                            <div className='field-container'>
                                <div className='input-group' style={{width: '20rem'}}>
                                    <label htmlFor="">display row count</label>
                                    <input ref={numberOfRowsRef} defaultValue={10} min={10} max={30} type="number" onChange={(e) => handleRowNumberChanged(e)} />
                                </div>
                                <div className='input-group'>
                                    <i><SearchIcon width="1rem" color="var(--color-main-white)" /></i>
                                    <input type="text" name="" id="" placeholder='Search location' onChange={(e) => handelSearchChange(e)}/>
                                </div>
                            </div>
                            <div className='table-wrapper'>
                                <div className='row header'>
                                    <div className='cell' style={{flex: 0.2, minWidth: '3rem'}}>
                                        <span></span>
                                    </div>
                                    <div className='cell' style={{minWidth: '8.3rem'}}>
                                        <span>Sea Area</span>
                                    </div>
                                    <div className='cell' style={{minWidth: '8.3rem'}}>
                                        <span>Admin Level</span>
                                    </div>
                                    <div className='cell' style={{minWidth: '8.3rem'}}>
                                        <span>Min Wind Speed(kmph)</span>
                                    </div>
                                    <div className='cell' style={{minWidth: '8.3rem'}}>
                                        <span>Max Wind Speed(kmph)</span>
                                    </div>
                                    <div className='cell' style={{minWidth: '8.3rem'}}>
                                        <span>Min Wave Height(m)</span>
                                    </div>
                                    <div className='cell' style={{minWidth: '8.3rem'}}>
                                        <span>Max Wave Height(m)</span>
                                    </div>
                                    <div className='cell' style={{minWidth: '8.3rem'}}>
                                        <span>Previous Sea Condition</span>
                                    </div>
                                    <div className='cell' style={{minWidth: '8.3rem'}}>
                                        <span>Sea Condition</span>
                                    </div>
                                    <div className='cell' style={{minWidth: '8.3rem'}}>
                                        <span>Thunderstorm</span>
                                    </div>
                                    <div className='cell' style={{minWidth: '8.3rem'}}>
                                        <span>Start Date</span>
                                    </div>
                                    <div className='cell' style={{minWidth: '8.3rem'}}>
                                        <span>End Date</span>
                                    </div>
                                </div>

                                {pagination[selectedPagination]?.map((item, index) => {
                                    const currentRowState = TWTableData.find((row): row is { type: 'TW'; data: TWAdminData } => row.type === 'TW' && row.data.code === item.code )?.data ?? {
                                            isSelected: false,
                                            code: item.code,
                                            name: item.name,
                                            adminName: item.name,
                                            adminLevel: item.adminLevel,
                                            minWindSpeed: 0,
                                            maxWindSpeed: 0,
                                            minWave: 0,
                                            maxWave: 0,
                                            thunderstorm: "",
                                            prevSeaCondition: "",
                                            seaCondition: "",
                                            startDate: startDate,
                                            endDate: endDate,
                                        };

                                    return (
                                        <div key={index} className='row'>
                                            <div className='cell' style={{flex: 0.2, minWidth: '3rem'}}>
                                                <input type="checkbox" name={item.code} checked={currentRowState.isSelected} onChange={handleCheckBoxClick} />
                                            </div>
                                            <div className='cell' style={{minWidth: '8rem'}}>
                                                <span>{item.name}</span>
                                            </div>
                                            <div className='cell' style={{minWidth: '8rem'}}>
                                                <span>{item.adminLevel}</span>
                                            </div>
                                            
                                            <div className='cell' style={{minWidth: '8rem'}}>
                                                <input value={currentRowState.minWindSpeed || 0} type="number" name={item.code} onChange={handleTWMinWind} min={0}/>
                                            </div>
                                            <div className='cell' style={{minWidth: '8rem'}}>
                                                <input value={currentRowState.maxWindSpeed || 0} type="number" name={item.code} onChange={handleTWMaxWind} min={0} />
                                            </div>
                                            <div className='cell' style={{minWidth: '8rem'}}>
                                                <input value={currentRowState.minWave || 0} type="number" name={item.code} onChange={handleTWMinWave} min={0} />
                                            </div>
                                            <div className='cell' style={{minWidth: '8rem'}}>
                                                <input value={currentRowState.maxWave || 0} type="number" name={item.code} onChange={handleTWMaxWave} min={0} />
                                            </div>
                                            <div className='cell' style={{minWidth: '8rem'}}>
                                                <select name={item.code} value={currentRowState.prevSeaCondition || ''} onChange={handleTWPrevSeaCondition} disabled={true}>
                                                    <option value="">No Risk</option>
                                                    {twSeaCondition.map((opt, idx) => (
                                                        <option key={idx} value={opt.value}>{opt.name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className='cell' style={{minWidth: '8rem'}}>
                                                <select name={item.code} value={currentRowState.seaCondition || ''} onChange={handleTWSeaCondition} >
                                                    <option value="">No Risk</option>
                                                    {twSeaCondition.map((opt, idx) => (
                                                        <option key={idx} value={opt.value}>{opt.name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className='cell' style={{minWidth: '8rem'}}>
                                                <select name={item.code} value={currentRowState.thunderstorm || ''} onChange={handleTWThunderstorm} >
                                                    <option value="">No Risk</option>
                                                    {twThunderstorm.map((opt, idx) => (
                                                        <option key={idx} value={opt.value}>{opt.name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className='cell' style={{minWidth: '8rem', justifyContent: 'center'}}>
                                                <input type="datetime-local" value={currentRowState.startDate || startDate} name={item.code} onChange={handleTWStartDate} style={{width: '8rem'}} />
                                            </div>
                                            <div className='cell' style={{minWidth: '8rem', justifyContent: 'center'}}>
                                                <input type="datetime-local" value={currentRowState.endDate || endDate} name={item.code} onChange={handleTWEndDate} style={{width: '8rem'}} />
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                        <div className='pagination-wrapper'>
                            <div className='icon-page-box' style={{marginBottom: "0.7rem"}} onClick={(e) => paginationNavigation("prev")}>&lt;</div>
                            <div className='page-wrapper'>
                                {pagination.map((page, index) => (
                                    <div key={index} className={selectedPagination === index ? 'icon-page-box selected' : 'icon-page-box'} onClick={(e) => setSelectedPagination(index)}>{index + 1}</div>
                                ))}
                            </div>
                            <div className='icon-page-box' style={{marginBottom: "0.7rem"}} onClick={(e) => paginationNavigation("next")}>&gt;</div>
                        </div>
                    </div>
                )}

                {areaSelectType === 'map' && (
                    <div className='map-wrapper'>
                        <MapSelector type='TW' setData={TWTableDataRef} startDate={startDate} endDate={endDate} tableData={TWTableData} setTableData={setTWTableData} allowedAreas={allowedAreas}/>
                    </div>
                )}
            </div>
            <div className='details-selector-wrapper'>
                <div className='title'>
                    <span>Early Warning Details (Intended Dissemination of Information to People)</span>
                </div>
                <div className='details-selector-wrapper-form-container'>
                    <div className='form-container'>
                        <span>message body SMS - english</span>
                        <textarea ref={twTextAreaEnglishRef} name="" id=""></textarea>
                    </div>
                    <div className='form-container'>
                        <span>message body SMS - dhivehi</span>
                        <textarea ref={twTextAreaDhivehiRef} name="" id=""></textarea>
                    </div>

                    {COUNTRY === "SRI_LANKA" ? (
                        <div className='form-container'>
                            <span>message body SMS - sinhala</span>
                            <textarea ref={twTextAreaSinhalaRef} name="" id=""></textarea>
                        </div>
                    ) : COUNTRY === "MALDIVES" ? (
                        <div className='form-container'>
                            <span>message body SMS - Bengali</span>
                            <textarea ref={twTextAreaBengaliRef} name="" id=""></textarea>
                        </div>
                    ) : null}
                    
                    <div className='form-container' style={{alignItems: 'center'}}>
                        <span>report link</span>
                        <input ref={twReportedLinkRef} type='text' name="" id=""></input>
                    </div>
                    <div className='button-wrapper'>
                        <button onClick={(e) => handleGenerateEWMessageData(e)}>generate EW message data</button>
                    </div>

                    {/* More message options */}
                    <div className='message-more-wrapper'>
                        <div className='title-wrapper'>
                            <span className='title' onClick={() => setMessageAreaStatus(prevState => !prevState)}>More Messaging options..</span>
                            <div>
                                {messagingAreaStatus ? <UpIcon width='0.8rem' color='var(--color-text)' /> : <DownIcon width='1rem' color='var(--color-text)' />}
                            </div>
                        </div>
                        <div className='data-wrapper' style={{ maxHeight: messagingAreaStatus ? '500px' : '0' }}>
                            
                            <div className='messaging-legend-wrapper'>
                                <span>Message Placeholders</span>
                                <div>
                                    <span>Warning Id: {'${warningId}'}</span>
                                    <span>Warning Name: {'${warningName}'}</span>
                                    <span>Area Name: {'${areaName}'}</span>
                                    <span>Severity: {'${severity}'}</span>
                                    <span>Validity Start Time: {'${validityStart}'}</span>
                                    <span>Validity End Time: {'${validityEnd}'}</span>
                                </div>
                            </div>

                            <div className='form-container'>
                                <span>local message body - english</span>
                                <textarea ref={twTextAreaCusEnglishRef} name="" id=""></textarea>
                            </div>
                            
                            {COUNTRY === "SRI_LANKA" ? (
                                <>
                                    <div className='form-container'>
                                        <span>local message body - sinhala</span>
                                        <textarea ref={twTextAreaCusSinhalaRef} name="" id=""></textarea>
                                    </div>

                                    <div className='form-container'>
                                        <span>local message body - tamil</span>
                                        <textarea ref={twTextAreaCusTamilRef} name="" id=""></textarea>
                                    </div>
                                </>
                                
                            ) : COUNTRY === "MALDIVES" ? (
                                <>
                                    <div className='form-container'>
                                        <span>local message body - dhivehi</span>
                                        <textarea ref={twTextAreaCusDhivehiRef} name="" id=""></textarea>
                                    </div>

                                    <div className='form-container'>
                                        <span>local message body - Bengali</span>
                                        <textarea ref={twTextAreaCusBengaliRef} name="" id=""></textarea>
                                    </div>
                                </>
                                
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
            <div className='details-selector-wrapper'>
                <div className='title'>
                    <span>Early Warning Details (Additional Information to Support Approval)</span>
                </div>
                <div className='details-selector-wrapper-form-container'>
                    <div className='form-container' style={{alignItems: 'center'}}>
                        <span>supportive documents</span>
                        <div className="custom-upload-container">
                            <span className="upload-text">{fileName}</span>
                            <label className="browse-button">
                                Browse
                                <input type="file" ref={fileInputRef} onChange={handleFileChange} className="file-input" />
                            </label>
                            </div>
                    </div>
                </div>
            </div>

            <div className='details-selector-wrapper'>
                <div className='title'>
                    <span>Subscribers</span>
                </div>
                <div className='details-selector-wrapper-form-container'>
                <div className='subscribe-data-table-wrapper'>
                    <>
                        <div className='table-set-wrapper-ew' style={{marginTop: "1rem", display: 'flex', flexDirection: 'row', gap: '1rem'}}>
                            <GroupSelectTable selectedGroup={selectedGroups} setSelectedGroup={setSelectedGroups} type="INTERNAL" token={undefined}/>
                            <UserSelectTable  userSelect={selectedSubscribers} setUserSelect={setSelectedSubscribers} type="INTERNAL" token={undefined}/>
                        </div>
                    </>
                </div>
                </div>
                <div className="button-container" style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', padding: '1rem' }}>
                    <button style={{ padding: '0.6rem 2rem', border: 'none', borderRadius: '0.5rem', backgroundColor: 'var(--color-accent-bg)', color: 'var(--color-main-white)', cursor: 'pointer' }} onClick={(e) => {
                            showAlertDialog(
                                "Send dissemination messages",
                                "Are you sure you want to save selected subscribers and groups?",
                                handleSaveSubscribersAndGroupButtonClick, undefined
                            ) 
                        }}>Save subscribers and Groups</button>
                </div>
            </div>
            
            <div className='details-selector-wrapper'>
                <div className='title'>
                    <span>Custom Subscribers</span>
                </div>
                <div className='details-selector-wrapper-form-container'>
                    <div className='form-container' style={{ alignItems: 'center' }}>
                        <span>Custom Subscribers (CSV)</span>
                        <div className="custom-upload-container">
                            <span className="upload-text">{fileCSVName}</span>
                            <label className={csvData.length > 0 ? 'browse-button clear-btn' : 'browse-button'}>
                                { csvData.length > 0 ? (
                                    <button onClick={(e) => handleClearCSV()}>Clear</button>
                                ) : (
                                    <>
                                        Browse
                                        <input type="file" ref={fileInputCSVRef} onChange={handleCSVFileChange} className="file-input" accept='.csv,text/csv' style={{ textTransform: 'none' }} />
                                    </>
                                )}
                                
                            </label>
                        </div>
                    </div>
                    {csvErrors && (
                        <div className='csv-form-container'>
                            <span>{csvErrors}</span>
                            <span className='clear-button' onClick={(e) => clearCSV()}>Remove CSV</span>
                        </div>
                    )}
                    <div className='form-container' style={{ alignItems: 'center' }}>
                        <span>Custom Subscribers (CSV) Name</span>
                        <div className="custom-upload-container-picker">
                            <div className='pick-icon' onClick={(e) => setIsCSVDataPikerOpen(prevState => !prevState)}>
                                <FormIconDataPicker color='var(--color-text)' width='1rem'/>
                            </div>
                            <input type="text" ref={csvSubNameRef} placeholder={`Default name (${fileCSVName.split('.')[0]})`} />
                        </div>
                    </div>
                    <div className='check-form-container'>
                        <div className='check-box'>
                            <input type="checkbox" ref={subscriberSaveRef} id="save-subs_csv" />
                            <label htmlFor="save-subs_csv">Save subscribers data</label>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`button-wrapper`} style={{gridArea: 'button'}}>
                <div className={`left-side`}></div>
                <div className={`right-side`}>
                    <button className={`button-normal`} style={{backgroundColor: 'var(--color-main-red)'}}>cancel</button>
                    <button className={`button-normal`} onClick={(e) => 
                        showAlertDialog(
                            "Confirm Submit",
                            "Are you sure you want to submit this early warning?",
                            () => handleSaveClick(e), undefined)
                    }>save & submit</button>
                </div>
            </div>
            {isCSVDataPikerOpen && (
                <div className="data-picker-table-wrapper-new">
                    <div className="data-picker-table-container">
                        <div className="search-wrapper">
                            <input type="text" placeholder="Search CSVs" onChange={(e) => handleChangeExistingDataSearch(e)} />
                            <div className="search-icon">
                                <SearchIcon width="1rem" color="var(--color-main-white)" />
                            </div>
                            <div className="close-icon" onClick={(e) => setIsCSVDataPikerOpen(false)} >
                                <CloseIcon width="1.5rem" color="var(--color-text)" />
                            </div>
                        </div>
                        <div className="row header">
                            {/* <span style={{ width: '33%' }}>Country</span> */}
                            <span style={{ width: '100%' }}>CSV Name</span>
                        </div>
                        
                        {isCSVDataPickerLoading ? (
                            <div className="searching-data">
                                <img src={theme === 'dark' ? loadDarkIcon : theme === 'light' ? loadLightIcon : theme === 'colorful' ? loadLightIcon : ''} alt="" />
                                <span>Searching CSVs...</span>
                            </div>
                        ) : (
                            <div className="data-wrapper">
                                {existingCSVFilterData.map((sub, index) => (
                                    <div
                                        key={index}
                                        className="row"
                                        onClick={(e) => handleClickFilteredCSV(sub)}
                                    >
                                        <span style={{ width: '100%', textAlign: 'left' }}>{sub}</span>
                                    </div>
                                ))}
                            </div>
                        )}

                        {!isCSVDataPickerLoading && existingCSVFilterData.length === 0 && (
                            <div className="searching-data">
                                <span>No CSVs found.</span>
                            </div>
                        )}
                        
                    </div>
                </div>
            )}
            {alertDialogState && (
            <AlertDialog
                title={alertTitle}
                description={alertDescription}
                windowState={alertDialogState}
                setWindowState={setAlertDialogState}
                function={alertYesCallback}
                okFunction={alertOkCallback}
            />
            )}
            {isLoading && (
                <LoadingScreen />
            )}
        </div>
    )
}

export default TWWarning